<template>
    <div class="tit-box">
        <div class="tit-desc">
            <span>{{title == ''?$t('edit.title'):title}}</span>
            <a-checkbox :checked="data.is_show_title === 1" @change="isShowTitle">
                {{title == ''?$t('edit.hpInfo.showTitle'):'顯示'+title}}
            </a-checkbox>
        </div>
        <a-input
                :placeholder="title == ''?$t('edit.hpInfo.inputTitle'):'請輸入'+title"
                v-model="data.title"
                @change="titleChange" />
    </div>
</template>

<script>
    export default {
        name: "TitleEdit",
        props:{
            data:{
                type:Object,
                require: true
            },
            title:{
                type: String,
                default:''
            }
        },
        methods:{
            isShowTitle(e){
                this.$emit('isShowTitle',e.target.checked)
            },
            titleChange(e){
                this.$emit('titleChange',e.target.value)
            }
        }
    }
</script>

<style lang="less" scoped>
    /* 熱點編輯樣式 */
    .tit-box {
        padding: 10px 16px;
        .tit-desc {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
        }
    }
</style>
